import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';
import { useMelwaysInfo } from '@seek/melways-react';

import { useConfig } from 'src/context/config';
import { useAuthenticationStatus, useUser } from 'src/context/use-user';
import { Site } from 'src/types';

export const Header = ({ lean = false }) => {
  const { country } = useMelwaysInfo();
  const { config } = useConfig();
  const { SITE: site } = config;
  const authenticationStatus = useAuthenticationStatus();
  const { data: user } = useUser();
  const firstName = user?.viewer?.personalDetails.firstName || '';
  const lastName = user?.viewer?.personalDetails.lastName || '';
  const email = user?.viewer?.emailAddress || '';
  const currentUrl = typeof window !== 'undefined' ? location.pathname : '';
  const urlWithoutLang = currentUrl.replace(/^\/(en|th|id)/, '');
  const isLanguageSwitcher =
    site === Site.JOBSTREETID || site === Site.JOBSDBTH;
  const languageSwitcher = isLanguageSwitcher
    ? {
        en: {
          url: `${urlWithoutLang}`,
        },
        [country!]: {
          url: `/${country}${urlWithoutLang}`,
        },
      }
    : undefined;

  return (
    <ApacCandidateHeaderFooterLinkProvider value={{ sendLinkEvent: () => {} }}>
      <ApacCandidateHeader
        authenticationStatus={authenticationStatus}
        userProfile={{
          firstName,
          lastName,
          email,
        }}
        leanHeader={lean}
        activeGlobalTab="jobs"
        languageSwitcher={languageSwitcher}
        onLanguageSwitch={() => {}}
        widthMode="large"
        divider
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};
